import React, { useEffect } from 'react';

import useRouteStatus from '../../../hooks/useRouteStatus';
import useSession from '../../../hooks/useSession';
import { supportPhone } from '../../../lib/constants/SiteVariables';

export default function Error({ location }) {
  const [session, sessionActions] = useSession();

  useRouteStatus(location);

  useEffect(() => {
    sessionActions.finish();
  }, []);

  return (
    <div id="content" className="text-center">
      <h2 className="text-xl font-avenir-black text-navy-blue">
        We're experiencing technical difficulties
      </h2>
      <div className="my-2">
        We are unable to process your{' '}
        {session.hasApplication() ? 'application' : 'order'} right now due to
        technical difficulties. Please try again later.
      </div>
      Please contact us ASAP:
      <br />
      <a href="mailto: support@creditkey.com">support@creditkey.com</a> |{' '}
      {supportPhone}
    </div>
  );
}
